/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Image_Export_Export_ButtonInputs */

const en_image_export_export_button = /** @type {(inputs: Image_Export_Export_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Export ${i?.count} Images`)
};

const fr_image_export_export_button = /** @type {(inputs: Image_Export_Export_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exporter ${i?.count} images`)
};

const de_image_export_export_button = /** @type {(inputs: Image_Export_Export_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-Bilder exportieren`)
};

const it_image_export_export_button = /** @type {(inputs: Image_Export_Export_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esporta ${i?.count} immagini`)
};

const ru_image_export_export_button = /** @type {(inputs: Image_Export_Export_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт изображений ${i?.count}`)
};

const es_image_export_export_button = /** @type {(inputs: Image_Export_Export_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportar imágenes ${i?.count}`)
};

const zh_cn2_image_export_export_button = /** @type {(inputs: Image_Export_Export_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导出${i?.count}图像`)
};

const ja_image_export_export_button = /** @type {(inputs: Image_Export_Export_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 画像をエクスポート`)
};

const hi_image_export_export_button = /** @type {(inputs: Image_Export_Export_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} छवियों को निर्यात करें`)
};

const pt_pt2_image_export_export_button = /** @type {(inputs: Image_Export_Export_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportar imagens ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Export {count} Images" |
*
* @param {Image_Export_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_export_button = /** @type {((inputs: Image_Export_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_export_button(inputs)
	if (locale === "de") return de_image_export_export_button(inputs)
	if (locale === "it") return it_image_export_export_button(inputs)
	if (locale === "ru") return ru_image_export_export_button(inputs)
	if (locale === "es") return es_image_export_export_button(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_export_button(inputs)
	if (locale === "ja") return ja_image_export_export_button(inputs)
	if (locale === "hi") return hi_image_export_export_button(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_export_button(inputs)
	return en_image_export_export_button(inputs)
});